import {MessageCodes} from "../MessageCodes";
import Constants from "../Constants";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import OutputError from "../OutputError";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.THYD001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the flow rates between 100yr and FW profiles. These differences are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell></ResultHeaderCell>
                            <ResultHeaderCell colSpan={2}>Flow Rate (cfs)</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right'}}>100yr</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right'}}>FW</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: 125, textAlign: 'left'}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', width: 120}}>{r.yr100}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', width: 120}}>{ResultCellHighlight(r.yr100, r.fw)}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.THYD002.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the boundary conditions between 100yr and FW profiles. These differences are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={2}>Boundary Condition</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}>100yr</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left'}}>FW</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                (row.data || [{}]).map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: 250, textAlign: 'left'}}>
                                                {r.YR100.dn_text}
                                                {' '}={' '}
                                                {r.YR100.dn_value}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: 250, textAlign: 'left'}}>
                                                {ResultCellHighlight(r.YR100.dn_text, r.FW.dn_text)}
                                                {' '}={' '}
                                                {ResultCellHighlight(r.YR100.dn_value, r.FW.dn_value)}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.HYD000.error_id: {
            return `Flow could not be checked since both 100yr and FW profiles are not available or labeled in the plan.`
        }
        case MessageCodes.Internal.B13_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B13_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B13 = {
    RenderDescription,
}